import { FormFields } from "./CreateForm";
import React, { useEffect, useRef, useState } from "react";
import { useLoaderData, useParams } from "react-router-dom";
import useFetch from "./helpers/useFetch";
import { useAtomValue } from "jotai";
import { tokenState } from "./Home";
import { PageHeaderLink } from "./helpers/elements";
import { StyleProcessor } from "./helpers/StyleProcessor";
import { AppDetailLeftNav } from "./UpdateAppDetail";
import { useDeviceWidth } from "./useDeviceWidth";
import axios from "axios";

const UpdateAppCategory = () => {
    const { appId } = useParams();
    const { app } = useLoaderData();
    const appData = app?.data;
    const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();
    // const [appData] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/${appId}/`);
    const [defaultAppsCategory] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/category_list/`);
    const { rawToken, isLoggedIn, tokenData } = useAtomValue(tokenState);
    const [isSubmit, setIsSubmit] = useState(false);
    const [updateAppCategoryData, setUpdateAppCategoryData] = useState([]);
    const [updateAppCategoryResponseData, setUpdateAppCategoryResponseData] = useState({});
    const [selectedCategoryCount, setSelectedCategoryCount] = useState(0);
    const [selectedCategoryData, setSelectedCategoryData] = useState('');
    const selectedCategoryContainer = useRef(null);
    const categoryInputField = useRef(null);
    const categoryItemsContainer = useRef(null);

    useEffect(() => {
        const appCategory = appData?.category.length > 0 ? appData?.category.split(",") : [];
        setUpdateAppCategoryData(appCategory);
        setSelectedCategoryCount(appCategory?.length);
    }, [appData]);

    useEffect(() => {
        console.log(selectedCategoryCount);
        console.log(updateAppCategoryData);
        setSelectedCategoryCount(updateAppCategoryData?.length);
    }, [updateAppCategoryData]);

    function addToSelectedCategory(event) {
        const category_value_elem = document.querySelector('#id-new-app-category-value')
        const this_elem = event.currentTarget
        const category_name = this_elem.getAttribute('data-category_name')

        // if (categorySplit.length <= 4) {
        if (this_elem.getAttribute('data-category_item_selected') === 'false') {
            let categorySplit = category_value_elem.value.split(',');
            category_value_elem.value += `${category_name},`.trim();
            setSelectedCategoryData(category_value_elem.value);
            new StyleProcessor(this_elem).removeClass('bg-transparent').addManyClass('bg-green color-FFFFFF pct:w-96 mg-x-auto mg-y-2');
            this_elem.setAttribute('data-category_item_selected', true);
            selectedCategoryContainer.current.innerHTML += `<span id="id-category-${categorySplit.length}" class="d-inline-block h-5 lh-5 pad-x2 mg-x1 mg-y1 radius-round bg-lighter border:1px_solid_BBB font-bold">${category_name}</span>`;
            setSelectedCategoryCount(selectedCategoryCount + 1);
            if (selectedCategoryCount === 4 - 1) {
                categoryItemsContainer.current.childNodes.forEach((obj) => {
                    if (obj.getAttribute('data-category_item_selected') === "false") {
                        obj.setAttribute('disabled', 'true');
                    }
                }, this_elem);
            }
        } else if (this_elem.getAttribute('data-category_item_selected') === 'true') {
            const removeItemFromList = (arr, itemToRemove, countToRemove = 1) => {
                let index = arr.indexOf(itemToRemove);
                if (index !== -1) {
                    // If the item is found in the array
                    arr.splice(index, countToRemove); // remove the item from the array
                }
                return arr;
            }
            // this element has already been selected,
            // reverse the selection.
            // category_value_elem.value -= `${category_name}, `;
            category_value_elem.value = category_value_elem.value.replace(`${category_name},`.trim(), '');
            setSelectedCategoryData(category_value_elem.value);
            new StyleProcessor(this_elem).addClass('bg-transparent').removeManyClass('bg-green color-FFFFFF pct:w-96 mg-x-auto mg-y-2');
            this_elem.setAttribute('data-category_item_selected', false);
            selectedCategoryContainer.current.querySelector(`#id-category-${selectedCategoryCount}`).remove();
            setSelectedCategoryCount(selectedCategoryCount - 1);
            if (selectedCategoryCount < 4 + 1) {
                categoryItemsContainer.current.childNodes.forEach((obj) => {
                    if (obj.getAttribute('data-category_item_selected') === "false") {
                        obj.removeAttribute('disabled');
                    }
                }, this_elem);
            }
        }
        //  } else if (categorySplit.length === 4) {
        //   console.log("Max number of category reached")
        //   categoryItemsContainer.current.childNodes.forEach((obj) => {
        //     if (obj.getAttribute('data-category_item_selected') === "false") {
        //       obj.setAttribute('disabled');
        //     }
        //   }, this_elem);
        // } else {
        //   alert('Only four categories allowed.')
        //   // new Notification().addNotification("You can only select four categories.");
        // }
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setUpdateAppCategoryData(values => {
            if (values.includes(value)) {
                return values.filter((item) => item !== value);
            } else {
                return [...values, value]
            }
        });
    }

    const showLoadingState = (e) => {
        setIsSubmit(true);
    };

    const updateCategoryForm = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append("category", updateAppCategoryData);

        const updateAppURL = `${process.env.REACT_APP_BASE_URL}/app/${appId}/`;
        const headers = {
            'Accept': '*/*',
            // 'Origin': '*',
            'Authorization': `Bearer ${window.localStorage.getItem('nine_login')}`
        };
        const fetchInit = {
            method: 'PATCH',
            headers: headers,
            mode: 'cors',
            // body: formData,
            data: formData,
            cache: 'default',
        };
        // fetch(updateAppURL, fetchInit)
        axios(updateAppURL, fetchInit)
            .then(response => {
                if (response.status !== 200) throw response;
                // return response.json()
                return response.data;
            })
            .then(data => {
                setIsSubmit(false);
                setUpdateAppCategoryResponseData({
                    message: "App category update successful",
                    successful: true,
                    error: false
                });
            })
            .catch((error) => {
                let errorMessage = error.response?.data.error || "Unable to process request";
                // if (error.status === 401) {
                //     errorMessage = "Kindly login to update your Profile"
                // } else if (error.status === 400) {
                //     errorMessage = "Unable to perform update. Kindly fix any form errors and re-submit"
                // } else if (error.status === 500) {
                //     errorMessage = "Check your internet connection"
                // } else {
                //     // There is no network connection or the Server is not up.
                //     errorMessage = "Network Error"
                // }
                setUpdateAppCategoryResponseData({
                    message: errorMessage,
                    successful: false,
                    error: true
                });
                // reset the isSubmit loader
                setIsSubmit(false);
            });
    };

    return (
        <section className={"flex flex-row flex-nowrap justify-start pct:w-100 dark:bg-111314"}>
            {
                windowWidth >= deviceWidthEnum.laptop
                    ? <AppDetailLeftNav appName={appData?.name} pageName={"Category"} />
                    : null
            }
            <form action={""} method={"PATCH"} onSubmit={updateCategoryForm} className={"pct:w-100 lg:pct:w-56|mg-r-auto|mg-t8"}>
                {
                    windowWidth < deviceWidthEnum.laptop
                        ? <PageHeaderLink headerTitle={"Update Category"} />
                        : <PageHeaderLink headerTitle={"Category"} />
                }
                <section id="id-new-app-category-fragment" className={"new-app-category-fragment lg:pad-x2 dark:color-whitesmoke"}>
                    <div
                        className={"sticky px:top-80 d-block pct:w-100 bg-white bg-mica z-1 dark:bg-111314"}
                        ref={selectedCategoryContainer}>
                        {
                            updateAppCategoryData?.map((eachCategory, index) => (
                                <span key={index} id={`id-category-${index}`}
                                    className="d-inline-block h-5 lh-5 pad-x2 mg-x1 mg-y1 radius-round bg-lighter border:1px_solid_BBB font-bold dark:bg-222425|color-whitesmoke|border:1px_solid_darkgray">
                                    {eachCategory}
                                </span>
                            ))
                        }
                    </div>
                    {
                        updateAppCategoryResponseData?.successful
                            ? <div
                                className="sticky px:top-80 mg-x-auto text-center pct:w-64 pad-y2 radius-sm bg-green-inverse color-green">
                                {updateAppCategoryResponseData.message}
                            </div>
                            : null
                    }
                    {
                        updateAppCategoryResponseData?.error
                            ? <div
                                className="sticky px:top-80 mg-x-auto text-center pct:w-64 pad-y2 radius-sm bg-red-inverse color-red">
                                {updateAppCategoryResponseData.message}
                            </div>
                            : null
                    }
                    <div className="d-block fixed px:top-8 right-4 h-8 lh-8 pad-x1 text-center font-bold z-100">
                        {selectedCategoryCount} of 4
                    </div>
                    <section className={""} ref={categoryItemsContainer}>
                        {
                            defaultAppsCategory?.map((eachAppsCategory, index) => {
                                return (
                                    <div className={"relative"}>
                                        <input
                                            key={index}
                                            type="checkbox"
                                            name={"category"}
                                            id={`id-category-${index}`}
                                            className={"sibling-categoryname appearance-none d-block pct:w-96 h-8 lh-8 pad-x3 pad-y-3 border-0 radius2 text-left lg:hover:pct:w-100|mg-x-auto|bg-green-inverse|cursor-pointer disabled:color-light checked:bg-green|color-FFFFFF|pct:w-100|mg-x-auto|mg-y-2 transition:all_200ms_ease"}
                                            defaultChecked={appData?.category.split(",").includes(eachAppsCategory)}
                                            defaultValue={eachAppsCategory}
                                            onChange={handleChange}
                                            disabled={!updateAppCategoryData?.includes(eachAppsCategory) && updateAppCategoryData?.length === 4}
                                        />
                                        <label
                                            htmlFor={`id-category-${index}`}
                                            className="d-block abs top-0 left-0 h-8 lh-8 pad-x3 pad-y-3 border-0 radius2 text-left checked:sibling-categoryname:color-white"
                                            data-category_name={eachAppsCategory}
                                            data-category_item_selected={false}
                                            /*onClick={(event) => addToSelectedCategory(event)}*/>
                                            {eachAppsCategory}
                                        </label>
                                    </div>
                                )
                            })
                        }
                    </section>
                </section>

                <div className={"mg-t-4 mg-b2 pad-t4 pad-b4 bg-white-solid dark:bg-111314"}>
                    <button
                        type={"submit"}
                        className={"d-block pct:w-64 max-w-480 h-7 lh-7 mg-x-auto pad-x2 border-0 bg-green color-white radius decoration-none disabled:bg-green-inverse"}
                        onClick={showLoadingState}
                        disabled={updateAppCategoryData?.length < 1}
                    >
                        {isSubmit ? <span className='fa fa-spinner fa-spin'></span> : "Save"}
                    </button>
                </div>
            </form>
        </section>
    );
}
export default UpdateAppCategory;